// Worker self-reported highest education level. Stored as enum on
// `workerProfile.education` (Prisma `EducationLevel`). Free-text was
// dropped because it bred typos and gave employers nothing actionable —
// level alone is what employers filter by.

export const EDUCATION_LEVELS = [
  "THCS",
  "THPT",
  "TRUNG_CAP",
  "CAO_DANG",
  "DAI_HOC",
  "SAU_DH",
] as const;

export type EducationLevel = (typeof EDUCATION_LEVELS)[number];

export const EDUCATION_LEVEL_LABEL_VI: Record<EducationLevel, string> = {
  THCS: "THCS",
  THPT: "THPT",
  TRUNG_CAP: "Trung cấp",
  CAO_DANG: "Cao đẳng",
  DAI_HOC: "Đại học",
  SAU_DH: "Sau đại học",
};
